export default __webpack_public_path__ + "static/media/logo.d6bd2905.png";